import { Component, OnInit } from '@angular/core';
import { Animations, DankeComponent } from '@vhv/tarifrechner-common';
import { CyberBetriebsartComponent } from '../betriebsart/cyber-betriebsart.component';


@Component({
    animations: [Animations.slideInDownAnimation],
    templateUrl: 'cyber-anfrage-danke.component.html',
})
export class CyberAnfrageDankeComponent extends DankeComponent implements OnInit {

    ngOnInit(): void {
        super.ngOnInit();
        window.removeEventListener('beforeunload', CyberBetriebsartComponent.createMessageBeforeUnload);
    }

}
